import { HARDWARE_SOURCE_CONFIGS, HardwareSourceConfig } from "src/utils/ConfigConstant";

export const PCD_HARDWARE_SOURCE_LIST: string[] = getPcdHardwareSourcesFromConfig(HARDWARE_SOURCE_CONFIGS);

function getPcdHardwareSourcesFromConfig(hardwareSourceConfigs: Map<string, HardwareSourceConfig>): string[] {
    const pcdHardwareSourceList: string[] = [];

    hardwareSourceConfigs.forEach((config: HardwareSourceConfig, hardwareSource: string) => {
        if (config.supportPCDImageViewing) {
            pcdHardwareSourceList.push(hardwareSource);
        }
    });

    return pcdHardwareSourceList;
}